/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 *
 * Vietnamese (Vietnam): vi-vn
 */

/**
 * Translation file for vi-VN locale
 *
 * @file vi.js
 * @author Mohamed yasar arabath M
 */

const vi = {
  'common.OK': 'Ok',
  'common.CONTINUE': 'Tiếp tục',
  'browser.check.DONT_SHOW_AGAIN': 'Don\'t show me this again',
  'browser.check.SYS_REQUIREMENTS_LINK_TEXT': 'hệ điều hành và trình duyệt web được hỗ trợ',
  'browser.check.BROWSER_MESSAGE_TITLE': 'Trình duyệt của bạn <<name>> đã lỗi thời',
  'browser.check.BROWSER_MESSAGE_DESC': 'Để có trải nghiệm tốt nhất, vui lòng chọn một trong những trình duyệt mới nhất:',
  'browser.check.BROWSER_SKIP_NOW': 'Tạm thời bỏ qua',
  'browser.check.BROWSER_SUPPORTED_LINK_TEXT': 'Thông tin về các trình duyệt được hỗ trợ',
  'browser.check.BROWSER_UNSUPPORTED_TITLE': 'Trình duyệt của bạn, <<name>> không được hỗ trợ',
  'browser.check.BROWSER_UNSUPPORTED_DESC': 'Để có trải nghiệm tốt nhất, hãy chọn một trong những trình duyệt được hỗ trợ.',
  'browser.check.OS_UNSUPPORTED_TITLE': 'Hệ điều hành của bạn, <<name>> không được hỗ trợ',
  'browser.check.OS_UNSUPPORTED_DESC': 'While the product may work with no issues, please be aware that any problems you encounter might be resolved by trying with a device running a <<link>>',
  'errors.GENERIC_TITLE': 'Lỗi máy chủ',
  'errors.GENERIC_DESC': 'Rất tiếc, hệ thống hiện đang gặp sự cố. Vui lòng thử lại sau hoặc liên hệ bộ phận hỗ trợ.',
  'errors.HTTP_400_TITLE': 'Lỗi máy chủ',
  'errors.HTTP_400_DESC': 'Đã xảy ra lỗi trong quá trình xử lý yêu cầu của bạn.',
  'errors.HTTP_401_TITLE': 'Bạn đã đăng nhập chưa?',
  'errors.HTTP_401_DESC': 'Chúng tôi không thể truy xuất dữ liệu vì phiên đăng nhập của bạn có thể đã hết hạn.',
  'errors.HTTP_403_TITLE': 'Không được phép',
  'errors.HTTP_403_DESC': 'You don\'t have access to this resource.',
  'errors.HTTP_888_TITLE': 'Máy chủ phản hồi quá chậm',
  'errors.HTTP_888_DESC': 'Đã xảy ra lỗi trong quá trình xử lý yêu cầu của bạn.'
};

export default vi;
